export const SESSION_ASYNC_FETCH = 'SESSION_ASYNC_FETCH';
export const SESSION_ASYNC_FETCH_SUCCESS = 'SESSION_ASYNC_FETCH_SUCCESS';
export const SESSION_ASYNC_FETCH_FAILURE = 'SESSION_ASYNC_FETCH_FAILURE';
export const SESSION_ASYNC_FETCH_INVALIDATE = 'SESSION_ASYNC_FETCH_INVALIDATE';
export const SESSION_ALIVE_SUCCESS = 'SESSION_ALIVE_SUCCESS';
export const SESSION_LOGOFF_SUCCESS = 'SESSION_LOGOFF_SUCCESS';
